import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TagsFormatService } from '../tags/tags-format.service';
import { contains } from 'ramda/es';
import { environment as config } from '../../../environments/environment';

@Pipe({
  name: 'tagsFilter'
})
@Injectable()
export class TagsFilter implements PipeTransform {
  transform(tags: any[], field, ...values): any {
    if (!tags) return [];
    return tags.filter(tag => {
      return values.some(value => {
        return tag[field].indexOf(value) >= 0;
      });
    });
  }
}

@Pipe({
  name: 'tagsOmit'
})
@Injectable()
export class TagsOmit implements PipeTransform {
  transform(tags: any[], field, ...values): any {
    if (!tags) return [];
    return tags.filter(tag => !contains(tag[field], values));
  }
}

@Pipe({
  name: 'renderTags'
})
@Injectable()
export class RenderTags implements PipeTransform {
  constructor(private tagFormatService: TagsFormatService) {}
  transform(text: string, tags): any {
    if (!text) return '';
    const url = this.tagFormatService.makeText(text, tags, (name, value) => value, 0);
    return /^https?:\/\//.test(url) ? url : `${config.livee.tag}${url}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/customization/tags.pipe.ts